module.exports = __webpack_public_path__ + "media/images/crypto-currencies/dash-e01c021b13f0881314193049bf4bc42d.svg";